'use client'

import { useEffect, useRef, useState } from "react"
import styles from "./ua.module.scss";
import Dropdown from "@/components/dropdown/Dropdown";
import Button from "@/components/button/Button";
import Form from "@/components/form/Form";
import Field from "@/components/form/Field";
import ApiUtils from "@/utils/ApiUtils";
import Icon from "@/components/icon/Icon";
import { useRouter } from "next/navigation";
import LocationDropdown from "./LocationDropdown";
import { emitEvent } from "@/components/plugins/EventListener";

export default function HeaderLocationButton(props) {
  
  const dd = useRef()

  const [location,setLocation] = useState(props.site?.session?.vehicles?.location || {})

  useEffect(() => {
    if (!props.site.isBot && !props.site.session?.vehicles?.location.manual) {
      navigator.geolocation.getCurrentPosition(function(position) {
        const currentZip = props.site.session?.vehicles?.location.zip
        ApiUtils.getRequest("/api/location/zip-code?lat=" + position.coords.latitude + "&lon=" + position.coords.longitude)
        .then(data => {
          ApiUtils.logEvent({ location: data.location })
          setLocation(data.location)
          emitEvent("location_updated", data)
          // if (data.location.zip != currentZip) {
          //   window.location.reload()
          // }
        })
      });
    }
  }, [])
  
  const onToggle = () => {
    dd.current.toggle()
  }
  
  return <>
    <Button plain={true} className={ styles.mi } onClick={e => onToggle(e)} label={ 'Update Your Location' }>
      <Icon {...props} name="map-marker"></Icon> <span className="min-i-lg">{ location.zip }</span>
    </Button>
    <LocationDropdown ref={dd} {...props}></LocationDropdown>
  </>

  
}